/*
 * 版权所有 (c) 华为技术有限公司 2024
 * Copyright (c) Huawei Technologies Co., Ltd. 2024. All rights reserved.
 */
import { ChangeDetectorRef, Component, EventEmitter, Input, Output } from '@angular/core';
import { I18nService } from '@dm/core';

import { type Lun } from '../../../../../../../../common/types/mo';
import { LUNMAPSUBTYPE } from '../../../../const';
import { InfigoService } from '../../../../infigo.service';

@Component({
    selector: 'app-mapping-lun-link',
    templateUrl: './mapping-lun-link.component.html',
    styleUrls: ['./mapping-lun-link.component.scss'],
})
export class MappingLunLinkComponent {
    @Input() data;
    @Input() name = 'displayedName';
    @Input() id = 'lunId';
    @Output() clickItem = new EventEmitter();
    lunTips = this.i18n.get('home.search_term_noInbandDetailInfo_info');
    toolTipVisible = false;
    jumpData = null;

    constructor(
        public infigoService: InfigoService,
        public changeDetectorRef: ChangeDetectorRef,
        public i18n: I18nService,
    ) { }

    onClick(item: { [x: string]: string; __actualId: any; displayedName: any; type: any }, e: { stopPropagation: () => void }): void {
        e.stopPropagation();
        if (this.jumpData) {
            this.clickItem.emit(this.jumpData);
            return;
        }
        if (this.jumpData === undefined) {
            this.toolTipVisible = true;
            this.changeDetectorRef.detectChanges();
            return;
        }
        if (!item[this.id]) {
            this.jump({
                id: item.__actualId,
                name: item.displayedName,
                precisionType: item.type,
                COMBINATION: '',
            });
            return;
        }
        this.infigoService.getLunSubType(item[this.id]).subscribe(({ data }: { data: Lun }): void => {
            if (LUNMAPSUBTYPE[data.SUBTYPE]) {
                this.jump({
                    id: data.ID,
                    name: data.NAME,
                    precisionType: LUNMAPSUBTYPE[data.SUBTYPE],
                    COMBINATION: '',
                });
                return;
            }
            this.jumpData = undefined;
            this.toolTipVisible = true;
            this.changeDetectorRef.detectChanges();
        });
    }

    mouseLeave(): void {
        this.toolTipVisible = false;
    }

    jump(data: { id: any; name: any; precisionType: any; COMBINATION: string }): void {
        this.jumpData = data;
        this.clickItem.emit(data);
    }
}
